import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import Navbar from "@/components/Navbar";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollManager from "@/components/ScrollManager";
import SiteFooter from "@/components/SiteFooter";
import CookieBanner from "@/components/CookieBanner";
import SiteAnalytics from "@/components/SiteAnalytics";

import Home from "@/pages/Home";
import Sets from "@/pages/Sets";
import SetDetail from "@/pages/SetDetail";
import CardDetail from "@/pages/CardDetail";
import SearchPage from "@/pages/Search";
import Collection from "@/pages/Collection";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Rankings from "@/pages/Rankings";
import Pricing from "@/pages/Pricing";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import Referrals from "@/pages/Referrals";
import PokemonIndex from "@/pages/PokemonIndex";
import Account from "@/pages/Account";
import AdminAnalytics from "@/pages/AdminAnalytics";
import Scan from "@/pages/Scan";
import Feed from "@/pages/Feed";
import PublicProfile from "@/pages/PublicProfile";
import Portfolio from "@/pages/Portfolio";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminContact from "@/pages/AdminContact";
import AdminPriceAudit from "@/pages/AdminPriceAudit";
import ForgotPassword from "@/pages/ForgotPassword";
import Sponsors from "@/pages/Sponsors";
import LegalNotice from "@/pages/legal/LegalNotice";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import Terms from "@/pages/legal/Terms";
import Cookies from "@/pages/legal/Cookies";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <CurrencyProvider>
              <SiteAnalytics />
              <ScrollManager />
              <Navbar />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/sets" element={<Sets />} />
                  <Route path="/sets/:id" element={<SetDetail />} />
                  <Route path="/cards/:id" element={<CardDetail />} />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/rankings" element={<Rankings />} />
                  <Route path="/index" element={<PokemonIndex />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/subscription/success" element={<SubscriptionSuccess />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/sponsors" element={<Sponsors />} />
                  <Route path="/feed" element={<Feed />} />
                  <Route path="/u/:id" element={<PublicProfile />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/legal" element={<LegalNotice />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/cookies" element={<Cookies />} />
                  <Route path="/scan" element={<ProtectedRoute><Scan /></ProtectedRoute>} />
                  <Route path="/collection" element={<ProtectedRoute><Collection /></ProtectedRoute>} />
                  <Route path="/portfolio" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
                  <Route path="/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
                  <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
                  <Route path="/admin/analytics" element={<ProtectedRoute><AdminAnalytics /></ProtectedRoute>} />
                  <Route path="/admin/contact" element={<ProtectedRoute><AdminContact /></ProtectedRoute>} />
                  <Route path="/admin/price-audit" element={<ProtectedRoute><AdminPriceAudit /></ProtectedRoute>} />
                </Routes>
              </main>
              <SiteFooter />
              <CookieBanner />
              <Toaster theme="light" position="bottom-right" richColors closeButton />
            </CurrencyProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
